import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {kitchenStaffTableReady,rowsPerPageState,searchTextState,paginationState,kitchenStaffIdForAction,previousFilterCity,previousFilterKitchenId} from '../redux/kitchen_staffs'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/kitchenStaffTable.css'


import {employeesMovementDataForAction} from '../../Employees Movement/redux/employeesmovement'

import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


import {Cities,Kitchens} from '../../../common/DropDowns/index'


import moment from 'moment'

import * as Helpers from '../../../common/helpers'


function filterUnwantedData(kitchenStaffsData) {
    let array = []
    if (kitchenStaffsData && kitchenStaffsData.data && kitchenStaffsData.data.list) {
        array = kitchenStaffsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""

            newLineData.employee_name = lineData.employee && lineData.employee.name ? lineData.employee.name : ""
            newLineData.employee_pk_id= lineData.employee && lineData.employee.id ? lineData.employee.id : ""
            newLineData.employee_id = lineData.employee && lineData.employee.code ? lineData.employee.code : ""
            newLineData.employee_mobile = lineData.employee && lineData.employee.mobile ? lineData.employee.mobile : ""

            newLineData.employee_designation = lineData.employee && lineData.employee.designation &&  lineData.employee.designation.name  ? lineData.employee.designation.name : ""

            newLineData.work_station = lineData.work_station && lineData.work_station.name ? lineData.work_station.name : "NA"

            newLineData.kitchen_name = lineData.kitchen && lineData.kitchen.name ? lineData.kitchen.name : "NA"
            newLineData.kitchen_code = lineData.kitchen && lineData.kitchen.code ? lineData.kitchen.code : "NA"

            newLineData.cluster_manager = lineData.kitchen && lineData.kitchen.cluster && lineData.kitchen.cluster.cluster_manager && lineData.kitchen.cluster.cluster_manager.name ? lineData.kitchen.cluster.cluster_manager.name : "NA"
            newLineData.cluster = lineData.kitchen.cluster && lineData.kitchen.cluster.name ? lineData.kitchen.cluster.name : "NA"

            newLineData.kitchen_manager = lineData.kitchen && lineData.kitchen.kitchen_manager && lineData.kitchen.kitchen_manager.name ? lineData.kitchen.kitchen_manager.name : "NA"

            newLineData.city_name =lineData.kitchen && lineData.kitchen.city && lineData.kitchen.city.name ? lineData.kitchen.city.name : "NA"

            newLineData.moving=false

            if(lineData.current_movements && lineData.current_movements.length>0){
                    newLineData.moving=true
            }

                newLineData.kitchen_movement={}
                newLineData.kitchen_movement.id = newLineData.employee_pk_id
                newLineData.kitchen_movement.code = newLineData.employee_id
                newLineData.kitchen_movement.name = newLineData.employee_name
                newLineData.kitchen_movement.mobile = newLineData.employee_mobile
                newLineData.kitchen_movement.kitchen_id = lineData.kitchen_id
                newLineData.kitchen_movement.kitchen_name=newLineData.kitchen_name
                newLineData.kitchen_movement.kitchen_staff_id =lineData.id 




            newArray[i] = newLineData
        }
    }
    return newArray
}


class KitchenStaffsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            kitchenStaffData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_kitchen_id:"",
            filter_city_id:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(kitchenStaffTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.KITCHEN_STAFFS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterCity=""
            let previousFilterKitchenId=""

         if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousFilterCity && this.props.kitchen_staffs.previousFilterCity!==undefined) {
            previousFilterCity=this.props.kitchen_staffs.previousFilterCity
         }         

         if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousFilterKitchenId && this.props.kitchen_staffs.previousFilterKitchenId!==undefined) {
            previousFilterKitchenId=this.props.kitchen_staffs.previousFilterKitchenId
         }
         
         this.setState({
              filter_city:previousFilterCity,
              filter_kitchen_id:previousFilterKitchenId
         },() => {
            this.getKitchenStaffsData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }

     createCSVData(csvData) {
        let kitchenList = []
        if (csvData) {
            kitchenList = JSON.parse(JSON.stringify(csvData))
            kitchenList = createXLSheetdata(kitchenList)
        }
        this.CSVData = kitchenList
    }


    
    getKitchenStaffsData = () => {
        apiService.getKitchenStaffsData(this.state.filter_city_id,this.state.filter_kitchen_id)
            .then(kitchenStaffsData => {
                if (kitchenStaffsData && this.isComponentMounted) {
                    this.validateBuildNumber(kitchenStaffsData)
                    if (kitchenStaffsData.status === "SUCCESS") {
                        let array = filterUnwantedData(kitchenStaffsData), pageNo = 1
                        if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousPaginationValue) {
                            pageNo = this.props.kitchen_staffs.previousPaginationValue
                        }
                        this.setState({
                            kitchenStaffData: array,
                            page: pageNo,
                        })


                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: kitchenStaffsData.reason ? kitchenStaffsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(kitchenStaffTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitchenStaffTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     entityStatusChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
             this.setState({
                filter_city :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
                filter_city :data.value,            
            })
        }
    }

    


    kitchenChange = (data) => {

       
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterKitchenId(""))
             this.setState({
                filter_kitchen_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterKitchenId(data.value))
             this.setState({
            filter_kitchen_id :data.value,
            
        })
        }
    }
    cityChange = (data) => {

        
        if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
              this.setState({
                filter_city_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
            filter_city_id :data.value,
            
            })
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousRowsPerPageValue) {
            value = this.props.kitchen_staffs.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {


        let kitchenStaffListFilename = "kitchens_staff_list_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/kitchenStaffs/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(kitchenStaffIdForAction())
                                        this.props.history.push("/dashboard/kitchenStaffs/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}


                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>

                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity={this.state.filter_city_id} selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                            </div>
                   
                   

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredKitchenStaffList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={kitchenStaffListFilename}>
                            Export
                        </CSVLink>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.kitchenStaffData.length>=(this.props.kitchen_staffs.previousPaginationValue*this.props.kitchen_staffs.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.kitchen_staffs.previousPaginationValue*this.props.kitchen_staffs.previousRowsPerPageValue)-this.props.kitchen_staffs.previousRowsPerPageValue+1} to {this.props.kitchen_staffs.previousPaginationValue*this.props.kitchen_staffs.previousRowsPerPageValue} of {this.state.kitchenStaffData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.kitchen_staffs.previousPaginationValue*this.props.kitchen_staffs.previousRowsPerPageValue)-this.props.kitchen_staffs.previousRowsPerPageValue+1} to {this.state.kitchenStaffData.length} of {this.state.kitchenStaffData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredKitchenStaffList = () => {
       
        this.props.dispatch(kitchenStaffTableReady(false))
        this.resetSearchAndPagination()
        this.getKitchenStaffsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getKitchenStaffsData()
        this.props.dispatch(kitchenStaffTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }


    resetFilterValues = () => {
        this.props.dispatch(kitchenStaffTableReady(false))
        this.setState({
            filter_city:"",
            filter_kitchen_id:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousFilterKitchenId(""))

            this.getKitchenStaffsData()
        });

        
    }

     moveEmployee = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesMovementDataForAction(row.kitchen_movement))
            this.props.history.push("/dashboard/employeeMovements/add")
        } else {
            this.dialog.show({
                title: "Employees Movement data not found",
                body: 'Employees Movement data is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


    actionButtonsCreator = (cell, row) => {
        let editButton =""
        let employeeMovement=""

        if(Helpers.checkPrivileges("/dashboard/kitchenStaffs/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editKitchenStaff(row)
                }}>
                Edit
            </button>
        }

        if(Helpers.checkPrivileges("/dashboard/employeeMovements/add",this.props.user) && !row.moving){

        employeeMovement=<button
                title="Employee Movement"
                className="action-button"
                style={{ marginBottom: "1px", background : "orange"}}
                onClick={(e) => {
                    e.preventDefault()
                    this.moveEmployee(row)
                }}>
                <i title="Employee Movement" className="icon-move" aria-hidden="true"> Move Employee</i>
            </button>

        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}{employeeMovement}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousPaginationValue
            && this.props.kitchen_staffs.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editKitchenStaff = (row) => {
        if (row && row.id) {
            this.props.dispatch(kitchenStaffIdForAction(row.id))
            this.props.history.push("/dashboard/kitchenStaffs/addEdit")
        } else {
            this.dialog.show({
                title: "KitchenStaff Identification number not found",
                body: 'KitchenStaff id is not available, So not able edit kitchenStaff',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.kitchen_staffs && this.props.kitchen_staffs.previousRowsPerPageValue) {
            sizeperPage = this.props.kitchen_staffs.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="kitchenStaffs-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.kitchenStaffData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                    
                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}

       
                    <TableHeaderColumn
                        dataField="employee_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp. Name
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="employee_designation"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Designation
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="kitchen_code"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Code
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_name"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="work_station"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Work Station
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_manager"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Mngr.
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cluster"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Cluster
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cluster_manager"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Cluster Mngr.
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="city_name"
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>                    
                    
                     <TableHeaderColumn
                        width="200"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kitchen_staffs: state.kitchen_staffs
    }
}

export default connect(mapStateToProps)(withRouter(KitchenStaffsTable))


// WEBPACK FOOTER //
// ./src/modules/Kitchen Staffs/Components/KitchenStaffsTable.js